import { initializeApp } from  "firebase/app";
import { group } from "../../a/group";

const firebaseConfig = {
    apiKey: group._ak,
    authDomain: group._ad,
    databaseURL: group._du,
    projectId: "gelo-website",
    storageBucket: group._sb,
    messagingSenderId: group._msi,
    appId: group._ai,
    measurementId: group._mi
  };


export const app = initializeApp(firebaseConfig);
